import { withAuthenticationRequired } from "@auth0/auth0-react";
import {
  BriefcaseIcon,
  SearchIcon,
  FingerPrintIcon,
  LinkIcon,
} from "@heroicons/react/outline";
import Loading from "../loading/loading";

const features = [
  {
    name: "1. Automated Daily Search",
    description:
      'Harvel scans the internet on a daily basis, looking for your content on pirated websites. Once we detect, we showcase the links in "Content" tab.',
    icon: SearchIcon,
  },
  {
    name: "2. Human Checks",
    description:
      "After we find where piracy happens, Harvel staff checks all links to make sure its a correct link.",
    icon: FingerPrintIcon,
  },
  {
    name: "3. DMCA Takedowns",
    description:
      "We then send takedown requests to the site, as well as Google, in order to take down the infringing content. We send weekly e-mails on status of your content",
    icon: BriefcaseIcon,
  },
  {
    name: "4. Manual Requests",
    description:
      'If you find any links that infringe your content, you can report them in the "Requests" tab, and our team will file a DMCA takedown on your behalf!',
    icon: LinkIcon,
  },
];

const HowItWorks = () => {
  return (
    <div className="py-12 bg-white mt-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:text-center">
          <h2 className="text-base text-brandcolor font-semibold tracking-wide uppercase">
            PROTECTING YOUR CONTENT
          </h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            You're Wondering How it Works?
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
            Our software helps crawl the internet and find websites where your
            content is infringed. We then take legal action to take it down!
          </p>
        </div>

        <div className="mt-10">
          <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
            {features.map((feature) => (
              <div key={feature.name} className="relative">
                <dt>
                  <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-brandblue text-white">
                    <feature.icon className="h-6 w-6" aria-hidden="true" />
                  </div>
                  <p className="ml-16 text-lg leading-6 font-medium text-gray-900">
                    {feature.name}
                  </p>
                </dt>
                <dd className="mt-2 ml-16 text-base text-gray-500">
                  {feature.description}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
};

export default withAuthenticationRequired(HowItWorks, {
  onRedirecting: () => <Loading />,
});
